import { useAtom } from 'jotai';
import { useResetAtom } from 'jotai/utils';

import { countryLangFiltersAtom } from '../store/atoms/countryLangFiltersAtom';
import type { CountryLangFilters } from '../types/countryLangFilters';

/**
 * Hook para gerenciar os filtros (client-side) da listagem de Idiomas do país.
 *
 * @returns Filtros atuais e funções para atualizar e resetar.
 */
export function useCountryLangFilters() {
  const [filters, setFilters] = useAtom(countryLangFiltersAtom);
  const resetFilters = useResetAtom(countryLangFiltersAtom);

  /**
   * Atualiza parcialmente os filtros. Reseta para a primeira página, exceto
   * quando o próprio `page` é fornecido no `partial` (navegação de páginas).
   */
  const updateFilters = (partial: Partial<CountryLangFilters>) => {
    setFilters(prev => {
      const resetPage = 'page' in partial ? {} : { page: 1 };
      return { ...prev, ...resetPage, ...partial };
    });
  };

  return { filters, updateFilters, resetFilters } as const;
}
